module.exports = __webpack_public_path__ + "4dd6cde04e8eeda76f3d632dedc75d6c.svg";